/**
 * Converts a ticker to a TradingView compatible ticker
 * @param ticker - The ticker from pattern to convert
 * @returns The converted ticker in TradingView format
 */
export const convertTickerForTradingView = (ticker: string) => {
    const fxcmPairs = [
        'EURUSD',
        'USDJPY',
        'GBPUSD',
        'USDCHF',
        'AUDUSD',
        'USDCAD',
        'NZDUSD',
        'EURGBP',
        'EURJPY',
        'EURCHF',
        'EURAUD',
        'EURCAD',
        'EURNZD',
        'GBPJPY',
        'GBPCHF',
        'GBPAUD',
        'GBPCAD',
        'GBPNZD',
        'CHFJPY',
        'AUDJPY',
        'AUDNZD',
        'AUDCHF',
        'AUDCAD',
        'CADJPY',
        'CADCHF',
        'NZDJPY',
        'NZDCHF',
        'NZDCAD',
        'XAUUSD',
    ];

    if (fxcmPairs.includes(ticker)) {
        return `All:${ticker}/FXCM`;
    }

    return ticker;
};
